<template>
  <v-app id="inspire">
    <v-dialog v-model="cargando" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Espere un momento
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-navigation-drawer
      color="fondomenu"
      width="350"
      dark
      v-model="drawer"
      app
      v-if="mostrarmenu"
    >
      <v-list dense>
        <MenuLink
          linkname="Beneficiarios"
          icon="mdi-card-account-details-outline"
          texto="Autorizaciones"
          @linkclickeado="drawer = false"
        ></MenuLink>
        <MenuLink
          linkname="BeneficiariosOspetax"
          icon="mdi-card-account-details-outline"
          texto="Autorizaciones-Ospetax"
          @linkclickeado="drawer = false"
        ></MenuLink>
        <MenuLink
          linkname="BeneficiariosOspical"
          icon="mdi-card-account-details-outline"
          texto="Autorizaciones-Ospical"
          @linkclickeado="drawer = false"
        ></MenuLink>
        <MenuLink
          linkname="ConsultaOrdenesOspetax"
          icon="mdi-card-account-details-outline"
          texto="Consulta de Autorizaciones-Ospetax"
          @linkclickeado="drawer = false"
        ></MenuLink>
        <MenuLink
          linkname="ConsultaOrdenesOspical"
          icon="mdi-card-account-details-outline"
          texto="Consulta de Autorizaciones-Ospical"
          @linkclickeado="drawer = false"
        ></MenuLink>
        <MenuLink
          linkname="ConsultaOrdenes"
          icon="mdi-card-account-details-outline"
          texto="Consulta de Autorizaciones"
          @linkclickeado="drawer = false"
        ></MenuLink>
        <MenuLink
          linkname="AtencionBeneficiario"
          icon="mdi-tray-full"
          texto="Atencion al Beneficiario"
          @linkclickeado="drawer = false"
        ></MenuLink>
        <MenuLink
          linkname="AuditoriaMedica"
          icon="mdi-tray-full"
          texto="Auditoria Medica"
          @linkclickeado="drawer = false"
        ></MenuLink>
        <MenuLink
          linkname="BandejaInternaciones"
          icon="mdi-tray-full"
          texto="Bandeja Internaciones"
          @linkclickeado="drawer = false"
        ></MenuLink>
        <MenuLink
          linkname="BandejaInternacionesOspetax"
          icon="mdi-tray-full"
          texto="Bandeja Internaciones - OSPETAX"
          @linkclickeado="drawer = false"
        ></MenuLink>
        <MenuLink
          linkname="BandejaInternacionesOspical"
          icon="mdi-tray-full"
          texto="Bandeja Internaciones - OSPICAL"
          @linkclickeado="drawer = false"
        ></MenuLink>
        <MenuLink
          linkname="ListaUltimasAutorizaciones"
          icon="mdi-tray-full"
          texto="Ultimas Autorizaciones"
          @linkclickeado="drawer = false"
        ></MenuLink>
        <MenuLink
          linkname="Patologias"
          icon="mdi-test-tube"
          texto="Patologias"
          @linkclickeado="drawer = false"
        ></MenuLink>
        <MenuLink
          linkname="Cartilla"
          icon="mdi-book-open-page-variant"
          texto="Cartilla"
          @linkclickeado="drawer = false"
        ></MenuLink>
        <MenuLink
          linkname="PatologiasBeneficiarios"
          icon="mdi-microscope"
          texto="Patologias Beneficiarios"
          @linkclickeado="drawer = false"
        ></MenuLink>
        <MenuLink
          linkname="PatologiasOspetax"
          icon="mdi-microscope"
          texto="Patologias Ospetax"
          @linkclickeado="drawer = false"
        ></MenuLink>
        <MenuLink
          linkname="PatologiasOspical"
          icon="mdi-microscope"
          texto="Patologias Ospical"
          @linkclickeado="drawer = false"
        ></MenuLink>
        <MenuLink
          linkname="ABMMotivos"
          icon="mdi-microscope"
          texto="ABMMotivos"
          @linkclickeado="drawer = false"
        ></MenuLink>
        <MenuLink
          linkname="ABMDiagnosticos"
          icon="mdi-medical-bag"
          texto="Diagnosticos"
          @linkclickeado="drawer = false"
        ></MenuLink>
        <MenuLink
          linkname="Reportes"
          icon="mdi-chart-areaspline"
          texto="Reportes"
        ></MenuLink>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app dark color="headeryfooter">
      <v-app-bar-nav-icon
        v-if="mostrarmenu"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="hidden-sm-and-down">
        <v-img src="@/assets/logo.png"></v-img>
      </v-toolbar-title>
      <v-divider class="mx-4 hidden-sm-and-down" vertical></v-divider>
      <v-toolbar-title class="hidden-sm-and-down"
        >Autorizaciones</v-toolbar-title
      >
      <v-divider class="mx-4 hidden-sm-and-down" vertical></v-divider>
      <v-spacer class="hidden-sm-and-down"></v-spacer>
      <v-toolbar-title class="hidden-sm-and-down">
        <b>{{ titulo }}</b>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-divider class="mx-4 hidden-sm-and-down" vertical></v-divider>
      <Bienvenido></Bienvenido>
    </v-app-bar>
    <v-main class="patron">
      <Navegacion></Navegacion>
      <v-container fluid>
        <v-row>
          <v-col>
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-footer color="headeryfooter" app>
      <v-row no-gutters>
        <v-col class="white--text text-right">V.{{ version }}</v-col>
      </v-row>
    </v-footer>
    <Snackbar></Snackbar>
  </v-app>
</template>

<script>
import { mapState, mapActions } from 'vuex'
//import { mdiCardAccountDetails } from "@mdi/js";

import Bienvenido from '@/components/Bienvenido'
import MenuLink from '@/components/MenuLink'
import Snackbar from '@/components/Snackbar'
import Navegacion from '@/components/Navegacion'
export default {
  name: 'App',
  components: {
    Bienvenido,
    MenuLink,
    Snackbar,
    Navegacion
  },
  props: {
    source: String
  },
  computed: {
    ...mapState('comun', ['Loading', 'Permisos']),
    cargando: function () {
      if (this.Loading > 0) {
        return true
      }
      return false
    },
    titulo() {
      return this.$route.meta.titulo || ''
    },
    permitido() {
      let permito = this.Permisos.find(
        (x) => x.descripcion_permiso === 'MotivosDeBaja'
        // || x.descripcion_permiso === "Seccionales"
        // || x.descripcion_permiso === "DocumentosxTipo"
        // || x.descripcion_permiso === "Tipo_afiliacion"
        // || x.descripcion_permiso === "Tipo_documentaciones"
        // || x.descripcion_permiso === "SituacionRevista"
      )
      return permito !== undefined
    },
    mostrarmenu() {
      let ret = false
      if (
        this.$route.path.split('/')[1].toUpperCase() !=
          'AUTOGESTIONBENEFICIARIOS' &&
        this.$route.path.split('/')[1].toUpperCase() !=
          'MICROSITIOPRESTADORES' &&
        this.$route.name.toUpperCase() !== 'AUTOGESTION' &&
        this.$route.name.toUpperCase() !== 'MICROSITIO'
      ) {
        ret = true
      }
      return ret
    }
  },
  methods: {
    ...mapActions('comun', ['inicializar', 'traerUserId']),
    ...mapActions(['cargarData']),
    cerrar() {
      this.drawer = false
    }
  },
  data: () => ({
    drawer: true,
    version: '1.230724-1'
  }),
  mounted() {},
  async created() {
    if (
      this.$route.name.toUpperCase() !== 'AUTOGESTION' &&
      this.$route.name.toUpperCase() !== 'MICROSITIO' &&
      this.$route.name.toUpperCase() !== 'RECUPERARCONTRASENA' &&
      this.$route.name.toUpperCase() !== 'VERCARTILLA' &&
      this.$route.name.toUpperCase() !== 'CARTILLAOSEIV'
    ) {
      if (this.$route.name !== 'Wellcome') {
        await this.inicializar()
        this.cargarData()
        this.traerUserId()
      }
    }
  }
}
</script>
